<template>
  <div class="whats-next">
    <div
      class="whats-next__items"
      :style="{'--items-count': items.length}">
      <div
        v-for="(item, index) in items"
        :key="`whats-next-${index}`"
        class="whats-next__item">
        <div class="whats-next__item-number">
          {{ index + 1 }}
        </div>
        <div class="whats-next__item-text">
          {{ item }}
        </div>
        <div
          v-if="index < items.length - 1"
          class="whats-next__item-separator" />
      </div>
    </div>
    <button
      class="button button-main"
      @click="$vuedals.dismiss()">
      Got it
    </button>
  </div>
</template>

<script>
export default {
  name: 'WhatsNextPopup',

  data() {
    return {
      items: [
        'You go over the order details',
        'We get in touch with you, and confirm your order',
        'A PRO player gets started on your order, and we keep track of the progress',
        'You check if everything\'s ok, and finish the order',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  .whats-next {
    display: flex;
    flex-direction: column;
  }

  .whats-next__item {
    position: relative;
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-gap: 16px;

    &:not(:first-child) {
      padding-top: 16px;
    }

    &:not(:last-child) .whats-next__item-text {
      margin-bottom: 16px;
    }
  }

  .whats-next__item-text {
    font-size: 13px;
    font-weight: 500;
    line-height: 1.2;
  }

  .whats-next__item-number {
    font-size: 19px;
    line-height: 1.2;
    font-weight: 500;
  }

  .whats-next__item-separator {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 100%;
    background-color: $color--basic-white;
    opacity: .25;
  }

  .button {
    padding: 12px;
    margin-top: 26px;
  }

  @media screen and (min-width: 601px) {
    .whats-next__items {
      display: grid;
      grid-template-columns: repeat(var(--items-count), 1fr);
      grid-gap: 24px;
    }

    .whats-next__item-text {
      margin: 0 !important;
      font-size: 11px;
    }

    .whats-next__item-text,
    .whats-next__item-number {
      text-align: center;
    }

    .whats-next__item {
      padding: 0 !important;
      grid-template-columns: 1fr;
      grid-template-rows: max-content 1fr;
    }

    .whats-next__item-separator {
      bottom: unset;
      height: 2px;
      top: 10px;
      left: 75%;
      width: 70%;
    }

    .button {
      align-self: center;
      padding: 15px;
      font-size: 15px;
    }
  }

  @media screen and #{$screen-more-or-1024} {
    .whats-next__items {
      grid-template-columns: repeat(var(--items-count), 116px);
    }
  }
</style>

<style lang="scss">
  .whats-next-popup {
    .mobile-panel-popup__head,
    .mobile-panel-popup__body {
      background-color: $color--basic-blue;
    }

    .mobile-panel-popup__bar {
      background-color: $color--basic-white;
      opacity: 0.25;
    }
  }
</style>
